import { isPlatform } from "@ionic/core";

export const isWeb = () => {
  if (
    isPlatform("mobileweb") ||
    isPlatform("desktop") ||
    isPlatform("pwa") ||
    isPlatform("electron")
  ) {
    return true;
  } else {
    return false;
  }
};
